import React from 'react';
import PropTypes from 'prop-types';

import OfficeInternetCopper from './productsSummary/officeInternetCopper';
import OfficeInternetFiber from './productsSummary/officeInternetFiber';
import TelusBusinessWifi from './productsSummary/telusBusinessWifi';
import OfficePhone from './productsSummary/officePhone';
import OptikTv from './productsSummary/optikTv';
import SecureBusiness from './productsSummary/secureBusiness';
import BasicWifiAp from './productsSummary/basicWifiAp';

const LineBreaks = ({ children }) => {
  return (
    <>
      {children}
      <br />
      <br />
    </>
  );
};

LineBreaks.propTypes = {
  children: PropTypes.node.isRequired
};

const ProductsSummary = ({
  products: {
    officeInternetCopper,
    officeInternetFiber,
    officePhone,
    optikTv,
    secureBusiness,
    basicWifiAp,
    telusBusinessWifi
  }
}) => {
  return (
    <>
      {officeInternetCopper && (
        <LineBreaks>
          <OfficeInternetCopper
            officeInternetCopper={officeInternetCopper}
          ></OfficeInternetCopper>
        </LineBreaks>
      )}
      {officeInternetFiber && (
        <LineBreaks>
          <OfficeInternetFiber
            officeInternetFiber={officeInternetFiber}
          ></OfficeInternetFiber>
        </LineBreaks>
      )}
      {telusBusinessWifi && (
        <LineBreaks>
          <TelusBusinessWifi
            telusBusinessWifi={telusBusinessWifi}
          ></TelusBusinessWifi>
        </LineBreaks>
      )}
      {basicWifiAp && (
        <LineBreaks>
          <BasicWifiAp basicWifiAp={basicWifiAp}></BasicWifiAp>
        </LineBreaks>
      )}
      {officePhone && (
        <LineBreaks>
          <OfficePhone officePhone={officePhone}></OfficePhone>
        </LineBreaks>
      )}
      {optikTv && (
        <LineBreaks>
          <OptikTv optikTv={optikTv}></OptikTv>
        </LineBreaks>
      )}
      {secureBusiness && (
        <LineBreaks>
          <SecureBusiness secureBusiness={secureBusiness}></SecureBusiness>
        </LineBreaks>
      )}
    </>
  );
};

ProductsSummary.defaultProps = {
  products: {}
};

ProductsSummary.propTypes = {
  products: PropTypes.objectOf(PropTypes.any)
};

export default ProductsSummary;
